import Events from "../../Events";


// TODO: удалить этот плагин, когда появится нормальный кэш

// есть триггеры, которые меняют состояние ID_PART_NUMBER_DUPLICATE, FIELDS_ERROR, LOG_ERROR_TEXT

export default Events.extend("StupidFixReloadPartNumberPositionErrorsOnDuplicate", {
    init(storage) {
        let update = storage.update;
        storage.update = function(id, changes, callback) {
            changes = changes || {};

            if ( !("PART_NUMBER" in changes) ) {
                return update.apply(storage, arguments);
            }

            update.call(storage, id, changes, (err, model) => {
                if ( err || !model ) {
                    return callback(err, model);
                }

                let partNumberId = model.get("ID_PART_NUMBER");
                if ( !partNumberId ) {
                    return callback(err, model);
                }


                storage.refreshGet({
                    columns: ["LOG_ERROR_TEXT", "FIELDS_ERROR", "IS_PART_NUMBER_DUPLICATE"],
                    filter: {
                        partNumber: {
                            key: "ID_PART_NUMBER",
                            type: "equal",
                            value: partNumberId
                        }
                    }
                }, () => {
                    callback(err, model);
                });
            });
        };
    }
});
